export const LOGO_HEADER_TYPE = Object.freeze({
  primary: 'primary',
  secondaryQida: 'secondaryQida',
  secondary: 'secondary',
})
